import { render, staticRenderFns } from "./produceIndex.vue?vue&type=template&id=67faad00&scoped=true"
import script from "./produceIndex.vue?vue&type=script&lang=js"
export * from "./produceIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67faad00",
  null
  
)

export default component.exports